











































































































































































































































































































import Vue, { PropType } from 'vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XPasswordInput from '@/components/atoms/Input/XPasswordInput.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XButtonGroup from '@/components/atoms/ButtonGroup/XButtonGroup.vue'
import XBirthdayPicker from '@/components/atoms/BirthdayPicker/XBirthdayPicker.vue'
import XCheckbox from '@/components/atoms/Checkbox/XCheckbox.vue'
import { MemberType, RegisterInput } from '@/types/generated/graphql'
import { Gender } from '@/store/types'
import { mapActions } from 'vuex'

export type DataType = {
  input: Partial<RegisterInput> & {
    passwordConfirm?: string
    agreeToPolicy: boolean
  }
  Gender: typeof Gender
}

export default Vue.extend({
  name: 'Signup',
  components: {
    XForm,
    XFormLabel,
    XInput,
    XPasswordInput,
    XCard,
    XButton,
    XButtonGroup,
    XBirthdayPicker,
    XCheckbox,
  },
  data(): DataType {
    return {
      input: {
        email: undefined,
        password: undefined,
        firstName: undefined,
        lastName: undefined,
        firstNameKana: undefined,
        lastNameKana: undefined,
        gender: undefined,
        birthday: undefined,
        height: undefined,
        weight: undefined,
        passwordConfirm: undefined,
        agreeToPolicy: false,
        memberType: this.memberType,
        partnerId: this.$route.query.p as string,
      },
      Gender,
    }
  },
  props: {
    memberType: {
      type: Object as PropType<MemberType>,
      default: MemberType.Owner,
    },
  },
  methods: {
    ...mapActions('auth', ['register']),
    async onRegister() {
      const { passwordConfirm, agreeToPolicy, ...input } = this.input
      await this.register(input).then(() => this.redirect())
    },
    redirect() {
      this.$router.replace(this.$route.params.wantedRoute || { name: 'Verify' })
    },
  },
})
